export default __webpack_public_path__ + "static/media/480_dummy2016-restaurant01-mobile-de.a29943a2.png";